import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { ExporterService } from '@shared/services/exporter/exporter.service';
import { PerfilService } from '@pages/perfil/services/perfil.service';
import { PerfilFormComponent } from './perfil-form/perfil-form.component';
import { MatDialog } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';
import { PerfilesPop } from '@pages/fabrica-credito/interfaces/perfil';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { DuplicarModeloComponent } from './copiar/duplicar-modelo/duplicar-modelo.component';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css'],
})
export class PerfilComponent implements OnInit, AfterViewInit {
  public columns: string[] = ['actions', 'clavePerfil', 'descripcion', 'scoreInicial'];

  public allData: number = 0;
  public loading: boolean = true;
  nodes: any[] = [];
  links: any[] = [];
  //layout: any[] = 'dagre';
  constructor(
    private _exportService: ExporterService,
    private _perfilService: PerfilService,
    public _dialog: MatDialog,
    private _swalService: SwalService,private router : Router
  ) {}
  
  ngOnInit(): void {
    //this.read();
  }
  private readonly _width: string = '900px';
  dataSource = new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  @ViewChild(MatSort)
  sort!: MatSort;
  GoToAppPopGrafico(){
    const email : string  = JSON.parse(sessionStorage.getItem("Usser").toLowerCase());
    const passwordEncryp : string  = sessionStorage.getItem("codePublic").trim();
    let url : string = environment.urlPopGrafico + "Loading/"+ email + "/" + passwordEncryp; 
    window.open(url, '_blank');
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  openCopiar() {
    const dialogRef = this._dialog.open(DuplicarModeloComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {});
  }

  read() {
    this._perfilService.read().subscribe((res) => {
      this.dataSource.data = res.data;
      if (res.data) this.allData = res.data.length;
      sessionStorage.setItem('perfiles', JSON.stringify(res.data));
      if (this.allData >= 0) this.loading = false;
    });
  }

  exportAsXLSX(): void {
    this._exportService.exportToExcel(
      this.dataSource.filteredData,
      'Perfiles_Optimos'
    );
  }

  openCreate() {
    const dialogRef = this._dialog.open(PerfilFormComponent, {
      width: this._width,
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  openUpdate(model: PerfilesPop) {
    sessionStorage.setItem('clavePerfil', JSON.stringify(model.clavePerfil));
    const dialogRef = this._dialog.open(PerfilFormComponent, {
      width: this._width,
      data: model,      
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.read();
    });
  }

  delete(model: PerfilesPop) {
    const dialogRef = this._dialog.open(ConfirmDeletionComponent, {
      width: '310px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this._perfilService.delete(model).subscribe((res) => {
          if (res.exito === 1) this._swalService.success('Eliminado');
          else this._swalService.error('No Eliminado');
          this.read();
        });
      }
    });
  }
}
